<template>
    <div class="timeline">
        <div v-for="index in nbItems" :key="index" class="timeline-skeleton-item">
            <div class="timeline-skeleton-item__icon">
                <CompassSkeleton
                    :variant="CompassEnums.SkeletonVariantType.SQUARE"
                    :size="CompassEnums.SkeletonSize.MEDIUM"
                />
            </div>
            <div class="timeline-skeleton-item__content">
                <CompassSkeleton
                    :variant="CompassEnums.SkeletonVariantType.LINE"
                    :size="CompassEnums.SkeletonSize.MEDIUM"
                    class="timeline-skeleton-item__title"
                />
                <CompassSkeleton
                    :variant="CompassEnums.SkeletonVariantType.LINE"
                    :size="CompassEnums.SkeletonSize.MEDIUM"
                    class="timeline-skeleton-item__description"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
interface Props {
    nbItems: number,
}

withDefaults(defineProps<Props>(), {
    nbItems: 5,
});
</script>

<style scoped lang="scss">
.timeline {
    margin-top: var(--spacing-5);
    margin-inline: var(--spacing-3);
}

.timeline-skeleton-item {
    display: flex;
    align-items: stretch;
    gap: var(--spacing-3);

    &__icon {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-shrink: 0;
    }

    &:not(:last-child) &__content {
        padding-bottom: var(--spacing-5);
    }

    &:not(:last-child) &__icon::after {
        content: '';
        flex: 1;
        width: 2px;
        background-color: var(--colors-common-background-subtle);
        margin-block: var(--spacing-2);
    }

    &__content {
        width: 100%;
    }

    &__title {
        width: 80px;
        margin-bottom: var(--spacing-2);
    }

    &__description {
        width: 100%;
        margin-bottom: var(--spacing-4);
    }
}
</style>